import React, { memo } from 'react';
import { Shape } from '../../types/Shape';
import HTMLShapeBase from './HTMLShapeBase';
import { linkifyText } from '../../utils/textUtils';

interface HTMLCircleProps {
  shape: Shape;
  isSelected: boolean;
  showResizeHandles?: boolean;
  stagePos: { x: number; y: number };
  stageScale: number;
  isDrawing?: boolean;
  isEditing?: boolean;
  currentTool?: string;
  onDragStart?: (shapeId: string) => void;
  onDragMove?: (shapeId: string, newX: number, newY: number) => void;
  onDragEnd?: (shapeId: string) => void;
  onResize?: (shapeId: string, newWidth: number, newHeight: number, newX?: number, newY?: number) => void;
  onResizeEnd?: () => void;
  onClick?: (shapeId: string, e: React.MouseEvent) => void;
  onDoubleClick?: (shapeId: string, e: React.MouseEvent) => void;
  onContextMenu?: (shapeId: string, e: React.MouseEvent) => void;
  onMouseEnter?: (shapeId: string) => void;
  onMouseLeave?: () => void;
  onStageClick?: (canvasX: number, canvasY: number, e: React.MouseEvent) => void;
}

const HTMLCircle: React.FC<HTMLCircleProps> = (props) => {
  const { shape, isEditing = false, stageScale } = props;

  return (
    <HTMLShapeBase {...props}>
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: shape.fill || '#FFFFFF',
          border: `${(shape.strokeWidth || 1) * stageScale}px solid ${shape.stroke || '#D1D5DB'}`,
          borderRadius: '50%',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
          position: 'relative',
        }}
      >
        {/* 텍스트 레이블 */}
        {shape.label && !isEditing && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
              width: '100%',
              padding: `${8 * stageScale}px`,
              fontSize: `${(shape.fontSize || 16) * stageScale}px`,
              color: 'black',
              lineHeight: 1.2,
              overflow: 'hidden',
              wordWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              pointerEvents: 'auto',
              userSelect: 'text',
              cursor: 'text',
            }}
            dangerouslySetInnerHTML={{ __html: linkifyText(shape.label || '') as string }}
          />
        )}
      </div>
    </HTMLShapeBase>
  );
};

export default memo(HTMLCircle);

